import pre from './pre';
import config from './config.vue';
import cart from './cart.vue';
import success from './success.vue';
export default {
  pre,
  components: {
    cart,
    config,
    success
  },
  post: () => { },
}
